import React from 'react';

const getFaqContent = (firstReadMore = null, secondReadMore = null) => [
    {
        question: 'How many designs of my logo do I get?',
        answer: (
            <>
                Every logo package includes the design selected at checkout. The <b>Professional</b> and{' '}
                <b>Unlimited</b> packages allow for additional design variations as long as the original design is
                available on the Logo Maker. {firstReadMore}
            </>
        ),
    },
    {
        question: 'Can I customize my logo after buying it?',
        answer: (
            <>
                You can customize your logo design in the Logo Maker editor before checkout, but only the{' '}
                <b>Professional</b> and <b>Unlimited</b> packages allow for customization after checkout.{' '}
                {secondReadMore}
            </>
        ),
    },
    {
        question: 'What payment methods do you accept?',
        answer: 'We accept Visa, Mastercard, Discover, JCB, Diners, and Paypal. We also accept iDeal, Sofort and Giropay.',
    },
    {
        question: 'Can I cancel my order?',
        answer: 'No. The logo files you get are non-refundable.',
    },
];

export default getFaqContent;
